import { render } from "./toast.vue?vue&type=template&id=ff79e49e"
import script from "./toast.vue?vue&type=script&lang=js"
export * from "./toast.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/lego/plugin/toast/toast.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "ff79e49e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('ff79e49e', __exports__)) {
    api.reload('ff79e49e', __exports__)
  }
  
  module.hot.accept("./toast.vue?vue&type=template&id=ff79e49e", () => {
    api.rerender('ff79e49e', render)
  })

}


export default __exports__